import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "infos" }
const _hoisted_3 = { class: "code" }
const _hoisted_4 = { class: "company ellipsis" }
const _hoisted_5 = {
  key: 0,
  class: "arrow"
}

import { useI18n } from "vue-i18n";

import type { ReportListType } from "@/common/types/report";

import { baseAvatar, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'card-report',
  props: {
    data: {},
    avatarSize: { default: "5rem" },
    active: { type: Boolean },
    showProgress: { type: Boolean, default: true },
    showArrow: { type: Boolean, default: false }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v28ab6444": (_ctx.avatarSize)
}))

const { t } = useI18n();

const props = __props;

const statusList: { [key: string]: string } = {
  pending: "time",
  started: "time-b",
  warning: "info",
  canceled: "close",
  finished: "confirmed",
};

const statusColor: { [key: string]: string } = {
  pending: "#666",
  started: "#666",
  warning: "red",
  canceled: "orange",
  finished: "green",
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-evaluation", { active: __props.active, 'no-progress': !__props.showProgress }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(baseAvatar), {
        url: __props.data?.evaluation?.company?.avatar?.small,
        size: __props.avatarSize
      }, null, 8, ["url", "size"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(props.data.code), 1),
          _createVNode(_unref(svgIcon), {
            size: "1.35rem",
            icon: statusList[props.data.status],
            color: statusColor[props.data.status]
          }, null, 8, ["icon", "color"])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.data.name), 1)
      ]),
      (__props.showArrow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(svgIcon), {
              icon: __props.active ? 'arrow-right' : 'arrow-down',
              size: "1rem"
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})